<template>
    <ListeParent/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeParent from "@/components/Parent/ListeParent.vue";

    export default defineComponent({
      name: "ListeParentPage",
      components: {
        
        ListeParent,
      },
    });
  </script>